import { Cookies } from 'react-cookie';

import { PeriodReportListItem } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getPeriodReportList = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/period_report/${slug}/`, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as PeriodReportListItem[];
};
